import React from 'react';
import { ProductCard } from './ui/ProductCard';
export function ProductGrid() {
  const products = [{
    title: 'Used EDM / CNC Inventory',
    description: 'Used Wire EDM, Sinker EDM, and CNC machines across many makes and models.',
    href: '59m7/used-machines.html'
  }, {
    title: 'Used AgieCharmilles and Mikron Experts',
    description: 'Trusted sourcing and support for precision pre-owned AgieCharmilles EDM and Mikron milling platforms.',
    href: 'GFMachiningSolutions.html'
  }, {
    title: 'Seibu America — Japanese Wire EDM',
    description: 'New Japanese Wire EDM product line—learn more about Seibu America.',
    href: 'https://seibu-america.com/',
    external: true,
    badge: 'NEW'
  }, {
    title: 'Breton Machine Tools',
    description: 'High-performance machining solutions for demanding manufacturing applications.',
    href: 'BretonMachineTools.html'
  }, {
    title: 'SPINNER Milling & Turning',
    description: 'Turning and mill/turn solutions built for precision and flexibility.',
    href: 'SpinnerMachineTools.html'
  }, {
    title: 'Campro Milling & Turning',
    description: 'Cost-effective CNC milling and turning solutions for production and prototyping.',
    href: 'Campro_Milling_Turning.html'
  }, {
    title: 'Bodor Laser Cutting',
    description: 'Fiber laser cutting solutions for sheet and tube applications.',
    href: 'BodorLaserCutting.html'
  }, {
    title: 'EDM — Electrical Discharge Machining',
    description: 'Wire EDM, sinker EDM, and EDM process solutions.',
    href: '59m7/edm.html'
  }, {
    title: 'Laser',
    description: 'Laser cutting and related laser manufacturing solutions.',
    href: '59m7/laser.html'
  }, {
    title: 'Machine Tool Automation',
    description: 'Automation solutions to improve throughput and consistency.',
    href: '59m7/automation.html'
  }, {
    title: 'EDM Parts & Consumables',
    description: 'EDM wear items, consumables, and parts support.',
    href: '29.html'
  }];
  return <section className="py-16 md:py-24 bg-gray-50" data-id="element-345">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-346">
        <div className="text-center mb-12" data-id="element-347">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-348">
            Product Lines & Solutions
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-349">
            Explore Peak's core equipment categories and product lines.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-350">
          {products.map((product, index) => <ProductCard key={index} title={product.title} description={product.description} href={product.href} external={product.external} badge={product.badge} data-id="element-351" />)}
        </div>
      </div>
    </section>;
}